export class Obstacle {
    courseId: string | null = null;
    courseName: string | null = null;
    name: string | null = null;
    position: number | null = null;
    type: string | null = null;
}
